//
// Copyright (c) 2023 Emplifi, Inc.
//

import { type DowncastConversionApi, Plugin, type ViewElement } from "ckeditor5";
import ResizeFigureCommand from "./resizeFigureCommand";

export default class ResizeFigureEditing extends Plugin {
  // noinspection JSUnusedGlobalSymbols
  static get pluginName() {
    return "ResizeFigureEditing";
  }

  init() {
    const editor = this.editor;
    const resizeFigureCommand = new ResizeFigureCommand(editor);
    this._registerSchema();
    this._registerConverters();
    editor.commands.add("resizeFigure", resizeFigureCommand);
  }
  private _registerSchema() {
    this.editor.model.schema.extend("media", { allowAttributes: "maxWidth" });
  }

  private _registerConverters() {
    const editor = this.editor;

    // model to view conversion
    editor.conversion.for("downcast").add((dispatcher) =>
      dispatcher.on(
        `attribute:maxWidth`,
        (evt, data, conversionApi: DowncastConversionApi) => {
          if (!conversionApi.consumable.consume(data.item, evt.name)) {
            return;
          }

          const viewWriter = conversionApi.writer;
          const figure = conversionApi.mapper.toViewElement(data.item);
          if (!figure) {
            return;
          }

          if (data.attributeNewValue !== null) {
            viewWriter.setStyle("max-width", data.attributeNewValue, figure);
            viewWriter.addClass("figure_resized", figure);
          } else {
            viewWriter.removeStyle("max-width", figure);
            viewWriter.removeClass("figure_resized", figure);
          }
        },
        { priority: "highest" },
      ),
    );

    editor.conversion.for("upcast").attributeToAttribute({
      view: {
        key: "class",
        value: "figure_resized",
      },
      model: {
        key: "maxWidth",
        value: (viewElement: ViewElement) => viewElement.getStyle("max-width"),
      },
    });
  }
}
